import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "el-collapse-item-title" }

import { ref, computed } from 'vue';
import { useStore } from 'vuex';
import LayerLegend from './LayerLegend.vue';
import ImageLegend from './ImageLegend.vue';

import {
  useTrack,
  FunctionIdEnum,
  EventTypeEnum,
} from '@/components/sendMetrics';


export default /*#__PURE__*/_defineComponent({
  __name: 'LegendDrawer',
  setup(__props) {

const { track } = useTrack();

const store = useStore();
const panels = computed(() => store.getters['maps/mapsLegends']);

const activeKeys = ref(panels.value.map((panel) => panel.id.toString()));
const components = {
  LayerLegend,
  ImageLegend,
};

const handleClick = (panel) => {
  track(
    FunctionIdEnum.globalLayer_legends_toggleLegendShow,
    EventTypeEnum.CLICK,
    { name: panel.title, ...panel },
  );
};

return (_ctx: any,_cache: any) => {
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createVNode(_component_el_empty, {
      description: _ctx.$t('nolegend'),
      "image-size": 80
    }, null, 8, ["description"]), [
      [_vShow, panels.value.length == 0]
    ]),
    _withDirectives(_createVNode(_component_el_collapse, {
      modelValue: activeKeys.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((activeKeys).value = $event))
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(panels.value, (panel) => {
          return (_openBlock(), _createBlock(_component_el_collapse_item, {
            key: panel.id,
            name: panel.id.toString(),
            onClick: () => handleClick(panel)
          }, {
            title: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, _toDisplayString(panel.title), 1)
            ]),
            default: _withCtx(() => [
              (_openBlock(), _createBlock(_resolveDynamicComponent(components[panel.type]), {
                url: panel.url,
                "show-title": false
              }, null, 8, ["url"]))
            ]),
            _: 2
          }, 1032, ["name", "onClick"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["modelValue"]), [
      [_vShow, panels.value.length > 0]
    ])
  ], 64))
}
}

})